<template>
  <div
    :class="
      twMerge(
        'text-[12px] leading-[8px] py-2 font-medium px-3 max-w-max text-white min-w-[102px] text-center' +
          '       rounded-b-[6px] absolute -top-1 before:content-[\'\'] before:h-[4px] before:w-[5px] before:block\n' +
          '        before:absolute before:-left-1 before:top-0 before:rounded-tl-[100px] after:content-[\'\']\n' +
          '        after:h-[4px] after:w-[4px] after:block after:absolute after:-right-1 after:top-0 after:rounded-tr-[100px]',
        variant === 'info' &&
          'bg-info ' +
            'before:bg-primary before:border-primary after:bg-primary after:border-primary',
        variant === 'success' &&
          'bg-success ' +
            'before:bg-success-hover before:border-success-hover after:bg-success-hover after:border-success-hover',
        variant === 'warning' &&
          'bg-[#fee200] text-natural-dark-grey ' +
            'before:bg-warning before:border-warning after:bg-warning after:border-warning',
        props.appendClass
      )
    "
    :data-testid="props.dataTestid + '-channel-tag'"
  >
    <slot>
      {{ props.label }}
    </slot>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

type Variants = "info" | "success" | "warning";

type Props = {
  variant?: Variants;
  label?: string;
  appendClass?: string;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  label: "Click & Collect",
  variant: "info",
});
</script>
